import SlotListCard from './SlotListCard/SlotListCard';
import { AppSettings } from '@opanuj/shared/types';
import { findSlotAvailabilityIssue } from '@opanuj/shared/slots';

function SlotsListView({
	slots,
	settings,
	selectedSlotId,
	selectedSlotIds,
	onSelectSlot,
	onToggleSlotSelection,
}: {
	slots: any[];
	settings: AppSettings;
	selectedSlotId: string | null;
	selectedSlotIds: string[];
	onSelectSlot: (slotId: string | null) => void;
	onToggleSlotSelection: (slotId: string) => void;
}) {
	const selectedSlot = slots.find((slot) => slot.id === selectedSlotId) ?? null;

	return (
		<>
			{slots.map((slot: any) => {
				const isActive = selectedSlotId === slot.id;
				const isMultiSelected = selectedSlotIds.includes(slot.id);
				const selectedConflictIssue =
					selectedSlot && slot.id !== selectedSlot.id
						? findSlotAvailabilityIssue(selectedSlot, [], [slot])
						: undefined;
				return (
					<div key={slot.id} data-slot-id={slot.id}>
						<SlotListCard
							slot={slot}
							settings={settings}
							isActive={isActive}
							isMultiSelected={isMultiSelected}
							selectedConflictIssue={selectedConflictIssue}
							onSelect={() => onSelectSlot(isActive ? null : slot.id)}
							onToggleSelection={() => onToggleSlotSelection(slot.id)}
						/>
					</div>
				);
			})}
		</>
	);
}

export default SlotsListView;
